module.exports = __webpack_public_path__ + "img/pu-coins.cae58499.png";